<div>
  <div class="dialog-body">
    <div class="dialog-content-description gea-font-body-16">
      <div>Resetting the workspace will undo changes made from the workspace’s inception or recent approval.</div>
      <div class="pt-4">Do you wish to proceed?</div>
    </div>
  </div>
  <p-divider />
  <div class="p-dialog-footer">
    <geaui-button-v3 (click)="cancel()" type="secondary">Cancel</geaui-button-v3>
    <geaui-button-v3 (click)="confirm()" information="error">Reset</geaui-button-v3>
  </div>
</div>
